import React, { useEffect, useContext } from 'react';
import { LoadingOverlay } from "../../../../../ab-common-legacy/LoadingOverlay";
import { EligibilityResultsContext, ProgramContext } from "../../../Providers";
import FallbackComponent from "../../FallbackComponent";
import MobileContent from "./Mobile";
import { useCefEventTracker } from "../../../Hooks/useCefEventTracker";
import { CefEvent, CefEventName, Platform } from "../../../../../EventTracker";
var Component = function Component(props) {
  var _eligibilityResults$r2;
  var onExit = props.onExit,
    application = props.application;
  var _useContext = useContext(ProgramContext),
    program = _useContext.program,
    isProgramLoading = _useContext.isLoading,
    fetchProgram = _useContext.fetchProgram;
  var _useContext2 = useContext(EligibilityResultsContext),
    eligibilityResults = _useContext2.eligibilityResults,
    fetchResults = _useContext2.fetchResults;
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;

  // eslint-disable-next-line no-restricted-syntax -- event tracking
  useEffect(function () {
    var _eligibilityResults$r;
    if (eligibilityResults !== null && eligibilityResults !== void 0 && (_eligibilityResults$r = eligibilityResults.result) !== null && _eligibilityResults$r !== void 0 && _eligibilityResults$r.eligibility) {
      var data = {
        eligible: eligibilityResults.result.eligibility !== 'ineligible'
      };
      trackEvent(CefEvent(CefEventName.Completed, Platform.Mobile, data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eligibilityResults === null || eligibilityResults === void 0 ? void 0 : (_eligibilityResults$r2 = eligibilityResults.result) === null || _eligibilityResults$r2 === void 0 ? void 0 : _eligibilityResults$r2.eligibility]);
  var result = eligibilityResults.result,
    searchData = eligibilityResults.searchData,
    isResultsLoading = eligibilityResults.isResultsLoading,
    hasFetchedMarketsData = eligibilityResults.hasFetchedMarketsData,
    isResultsFailed = eligibilityResults.isResultsFailed,
    alreadyAppliedMessage = eligibilityResults.alreadyAppliedMessage;

  // eslint-disable-next-line no-restricted-syntax -- TODO: refactor to use useQuery
  useEffect(function () {
    if (!hasFetchedMarketsData) return;
    if (program.id !== null) {
      fetchResults();
      fetchProgram();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFetchedMarketsData, JSON.stringify(application)]);
  if (alreadyAppliedMessage) {
    return /*#__PURE__*/React.createElement(FallbackComponent, {
      message: alreadyAppliedMessage,
      onExit: onExit
    });
  }
  if (isResultsFailed) {
    return /*#__PURE__*/React.createElement(FallbackComponent, {
      onExit: onExit
    });
  }
  if (program.id !== null) {
    if (isResultsLoading || !hasFetchedMarketsData || isProgramLoading) {
      return /*#__PURE__*/React.createElement(LoadingOverlay, {
        "aria-label": "Loading"
      });
    }
  }
  return /*#__PURE__*/React.createElement(MobileContent, {
    result: result,
    program: program,
    searchData: searchData
  });
};
export default Component;